import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const DAMAGE_PHOTOS_NAME = 'damage_photos';

const DamagePhotos = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać zdjęcia uszkodzeń?'),
    description: i18n.t(
      'Zadbaj o to, by zdjęcia były wyraźne i dokumentowały wszystkie widoczne uszkodzenia.'
    ),
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Zdjęcia uszkodzeń')}
        instructionProps={instructionProps}
        inputFieldName={DAMAGE_PHOTOS_NAME}
        attachmentTypeId={ATTACHMENT_TYPES.ZDJECIE_USZKODZEN}
        required
        data-testid={`${DAMAGE_PHOTOS_NAME}-uploader`}
      />
    </Card>
  );
};

export default DamagePhotos;
